'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        var $target, id;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
                // if no element found, create one
                if ($target.length === 0) {
                    id = params.target.substr(1);
                    $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
                }
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else if ($('#dialog-container').length > 0) {
            $target = $('#dialog-container');
        } else {
            $target = $('<div id="dialog-container"/>').appendTo('body');
        }

        if ((params.options != undefined && params.options != null) && (params.options.title == undefined || ('title' in params.options && params.options.title.length == 0))) {
            params.options.dialogClass += ' ui-dialog-title-collapse';
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));

        /* --- BOOT-5386 ---
         * This is a workaround for a known jquery Dialog UI bug with the maxWidth option. By setting the Dialog width option to 100% and setting the CSS max-width
         * to 800px, this allows the dialogs to be responsive width. This fix is necessary to create responsive Dialogs for smaller screens, but also be backwards 
         * compatible with existing dialogs on the site that have been previously set to the default size of 800px.
         * https://stackoverflow.com/questions/16471890/responsive-jquery-ui-dialog-and-a-fix-for-maxwidth-bug
         */
        var maxWidth = params.options != undefined && params.options != null && 'maxWidth' in params.options && params.options.maxWidth ? params.options.maxWidth : "800px";
        this.$container.parent().css("max-width", maxWidth);

        // Adding keyboard support for Enter key on close button
        this.$container.find(".ui-dialog-titlebar-close").on("keydown", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                $(this).trigger("click");
            }
        });
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        if (this.$container && this.$container.closest('.ui-dialog-close-on-retrigger').length && this.$container.dialog('isOpen')) {
            this.close();
            return;
        }
        // close any open dialog
        this.close();
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container || !this.$container.dialog("instance") || this.$container.find('[data-multi-layered="true"]').length) {
            return;
        }
        this.$container.dialog('close');
    },
    /**
     * @function
     * @description Submits the dialog form with the given action
     * @param {String} The action which will be triggered upon form submit
     */
    submit: function (action, callback) {
        var $form = this.$container.find('form:first');
        // set the action
        $('<input/>').attr({
            name: action,
            type: 'hidden'
        }).appendTo($form);
        // serialize the form and get the post url
        var data = $form.serialize();
        var url = $form.attr('action');
        // make sure the server knows this is an ajax request
        if (data.indexOf('ajax') === -1) {
            data += '&format=ajax';
        }
        // post the data and replace current content with response content
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'html',
            success: function (html) {
                this.$container.html(html);
                if (callback) {
                    callback();
                }
            }.bind(this),
            failure: function () {
                window.alert(Resources.SERVER_ERROR);
            }
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '100%',
        open: function(event, ui) {
            var $dialog = $(this);
            if ($dialog.closest('.ui-dialog-outer-click-close').length) {
                setTimeout(() => {
                    $dialog.off('outside.element.clicked');
                    $dialog.on('outside.element.clicked', function () {
                        $dialog.dialog('close');
                        $dialog.off('outside.element.clicked');
                    });
                }, 0);
            }
            $dialog.parent().addClass('ui-dialog-open');
            $('body').addClass('modal-open');
        },
        close: function () {
            var $dialog = $(this);
            $dialog.parent().removeClass('ui-dialog-open');
            $dialog.dialog('close');
            $dialog.off('outside.element.clicked');
            $('body').removeClass('modal-open');
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;
